import React from 'react';
import { Box, Typography } from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import StreamTile from './StreamTile';

const CameraWorkspace = React.memo(({
  workspaceRef,
  gridRef,
  tileMaxWidth,
  gridColumns,
  gridSize,
  gridOptions,
  activeStreamCount,
  isFullscreen,
  toggleFullscreen,
  renderedSlots,
  focusedSlot,
  dropTargetIndex,
  onGridSizeChange,
  onFocusSlot,
  onTileDragStart,
  onTileDragOver,
  onTileDragLeave,
  onTileDrop,
  onTileDragEnd
}) => (
  <Box className="cms-camera-workspace" ref={workspaceRef}>
    <Box
      className="cms-camera-workspace-inner"
      style={{
        maxWidth: tileMaxWidth
          ? `${tileMaxWidth * gridColumns + (gridColumns - 1) * 3}px`
          : '100%',
        width: '100%',
        margin: '0 auto'
      }}
    >
      <Box className="cms-camera-toolbar">
        <Typography variant="body2" className="cms-camera-toolbar-info">
          {activeStreamCount}/{gridSize} khung
        </Typography>
        <Box className="cms-camera-toolbar-actions">
          {gridOptions.map(option => (
            <button
              key={option.label}
              type="button"
              className={`cms-camera-grid-button ${gridSize === option.size ? 'active' : ''}`}
              onClick={() => onGridSizeChange(option.size)}
            >
              {option.label}
            </button>
          ))}
          <button
            type="button"
            className="cms-camera-fullscreen-button"
            onClick={toggleFullscreen}
          >
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </button>
        </Box>
      </Box>

      <Box
        className="cms-camera-grid"
        ref={gridRef}
        style={{
          gridTemplateColumns: tileMaxWidth
            ? `repeat(${gridColumns}, minmax(0, ${tileMaxWidth}px))`
            : `repeat(${gridColumns}, minmax(0, 1fr))`
        }}
      >
        {renderedSlots.map((slot, index) => (
          <StreamTile
            key={slot?.key || `placeholder-${index}`}
            slot={slot}
            isFocused={focusedSlot === index}
            isDropTarget={dropTargetIndex === index}
            onFocus={() => onFocusSlot(index)}
            onDragStart={event => onTileDragStart(event, index)}
            onDragOver={event => onTileDragOver(event, index)}
            onDragLeave={event => onTileDragLeave(event, index)}
            onDrop={event => onTileDrop(event, index)}
            onDragEnd={onTileDragEnd}
          />
        ))}
      </Box>
    </Box>
  </Box>
));

export default CameraWorkspace;
